module.exports = __webpack_public_path__ + "img/22.1a731ef9.gif";